// Auxiliary fields
const smartixAuxiliaryFields = {
  seat: [
    {
      "key": "__SMARTIX_SEAT__",
      "label": "seat",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{__seating__.__*_seat__}}"
    }
  ],
  row: [
    {
      "key": "__SMARTIX_ROW__",
      "label": "row",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{__seating__.__*_row__}}"
    },
    {
      "key": "__SMARTIX_SEAT__",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{__seating__.__*_seat__}}"
    }
  ],
  section: [
    {
      "key": "__SMARTIX_SECTION__",
      "label": "section",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{__seating__.__*_section__}}"
    },
    {
      "key": "__SMARTIX_ROW__",
      "label": "row",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{__seating__.__*_row__}}"
    },
    {
      "key": "__SMARTIX_SEAT__",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{__seating__.__*_seat__}}"
    }
  ],
  gate: [
    {
      "key": "__SMARTIX_GATE__",
      "label": "gate",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{__seating__.__*_gate__}}"
    },
    {
      "key": "__SMARTIX_SECTION__",
      "label": "section",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{__seating__.__*_section__}}"
    },
    {
      "key": "__SMARTIX_ROW__",
      "label": "row",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{__seating__.__*_row__}}"
    },
    {
      "key": "__SMARTIX_SEAT__",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{__seating__.__*_seat__}}"
    }
  ]
}

const standardAuxiliaryFields = {
  seat: [
    {
      "key": "SEAT",
      "label": "seat",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{seating.*_seat}}"
    }
  ],
  row: [
    {
      "key": "ROW",
      "label": "row",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{seating.*_row}}"
    },
    {
      "key": "SEAT",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{seating.*_seat}}"
    }
  ],
  section: [
    {
      "key": "SECTION",
      "label": "section",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{seating.*_section}}"
    },
    {
      "key": "ROW",
      "label": "row",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{seating.*_row}}"
    },
    {
      "key": "SEAT",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{seating.*_seat}}"
    }
  ],
  gate: [
    {
      "key": "GATE",
      "label": "gate",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{seating.*_gate}}"
    },
    {
      "key": "SECTION",
      "label": "section",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{seating.*_section}}"
    },
    {
      "key": "ROW",
      "label": "row",
      "textAlignment": "PKTextAlignmentCenter",
      "value": "{{seating.*_row}}"
    },
    {
      "key": "SEAT",
      "label": "seat",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{seating.*_seat}}"
    }
  ]
}

const smartixSecondaryFields = {
  single: [
    {
      "key": "__SMARTIX_VENUE__",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "Venue name"
    }
  ],
  multiple: [
    {
      "key": "__SMARTIX_VENUE__",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "Venue name"
    },
    {
      "key": "__SMARTIX_TICKET_TYPE__",
      "label": "ticket type",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{__*_ticket_type__}}"
    }
  ]
}

const standardSecondaryFields = {
  single: [
    {
      "key": "VENUE",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{event.venue}}"
    }
  ],
  multiple: [
    {
      "key": "VENUE",
      "textAlignment": "PKTextAlignmentLeft",
      "value": "{{event.venue}}"
    },
    {
      "key": "TICKET_TYPE",
      "label": "ticket type",
      "textAlignment": "PKTextAlignmentRight",
      "value": "{{*_ticket_type}}"
    }
  ]
}

const auxiliaryFields = {
  standard : standardAuxiliaryFields,
  smartix : smartixAuxiliaryFields
}

const secondaryFields = {
  standard : standardSecondaryFields,
  smartix : smartixSecondaryFields
}

export default {
  auxiliaryFields,
  secondaryFields
}